/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './PlayersMatchingView.scss'

export const JOIN_RANDOM_UNIT_AS_LEGIONARY = (
    <FormattedMessage
        id='players_matching.join_unit.title'
        defaultMessage='Сражаться легионером'
    />
)

export const OWN_CLAN_UNITS = (count) => (
    <FormattedMessage
        id='players_matching.own_clan_unit'
        defaultMessage='Отряды моего клана ({count})'
        values={{ count }}
    />
)

export const NO_OWN_CLAN_UNITS = (
    <FormattedMessage
        id='players_matching.no_own_clan_units'
        defaultMessage='У вашего клана нет сформированных отрядов'
    />
)

export const SELECTED_VEHICLES_COUNT = (selected, total) => {
    const selectedVehiclesClassName = selected > 0 ?
        styles.highlight :
        styles.error

    return (
        <FormattedMessage
            id='players_matching.selected_vehicles_count'
            defaultMessage='Выбрано машин: {selected} / {total}'
            values={{
                selected: (
                    <span className={selectedVehiclesClassName}>
                        {selected}
                    </span>
                ),
                total,
            }}
        />
    )
}

export const RESET_SELECTED_VEHICLES_TOOLTIP = {
    id: 'reset_selected_vehicles',
    title: (
        <FormattedMessage
            id='players_matching.reset_selected_vehicles.title'
            defaultMessage='Сбросить выбор техники'
        />
    ),
    message: (
        <FormattedMessage
            id='players_matching.reset_selected_vehicles.message'
            defaultMessage='Нажмите, чтобы выбрать всю технику, разрешённую в этом режиме.'
        />
    ),
}

export const INFO_TOOLTIP = {
    id: 'info_tooltip',
    message: (
        <FormattedMessage
            id='players_matching.info_tooltip.message'
            defaultMessage='Вы выйдите в бой с отрядом, которому нужна одна из выбранных вами машин.'
        />
    ),
}

export const INFO_FOR_LEGIONARY = (
    <FormattedMessage
        id='players_matching.info_for_legionary'
        defaultMessage='Отряд подберётся автоматически'
    />
)

export const AVAILABLE_DURING_CHALLENGES = (battle_mode) => (
    <FormattedMessage
        id='players_matching_available_during_challenges'
        defaultMessage='Автоматический подбор отряда в режиме "{battle_mode}" будет доступен в день Военных игр.'
        values={{ battle_mode }}
    />
)

export const FIND_UNITS_IN_UNITS_LIST = (
    <FormattedMessage
        id='players_matching.find_units_in_units_list'
        defaultMessage='Найти отряд в этот режим сейчас можно в списке отрядов.'
    />
)



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/translations.jsx